module.exports = __webpack_public_path__ + "static/devcon4-1-03f49eb399bf1775faa8eb1c86d7b55a.jpg";